// extracted by mini-css-extract-plugin
export default {"main_nav":"index_main_nav_E1u6m","box":"index_box_8FU0R","ad":"index_ad_Y-fis","search":"index_search_iMJKU","logo":"index_logo_TG6rT","userinfo":"index_userinfo_0o-CH"};